module.exports = __webpack_public_path__ + "static/media/npmmSearch.d7e6127e.PNG";